import script from "./InformationSeal.vue?vue&type=script&setup=true&lang=ts"
export * from "./InformationSeal.vue?vue&type=script&setup=true&lang=ts"

import "./InformationSeal.vue?vue&type=style&index=0&id=0b5b701f&lang=less&scoped=true"

import exportComponent from "D:\\work\\risfond-branchmanagementsystem\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b5b701f"]])

export default __exports__